import { Component, OnInit, Input } from '@angular/core';

import { Lagerplatz } from '../models/lagerplatz.model';


@Component({
  selector: 'sws-lagerplatzzeile',
  templateUrl: './lagerplatzzeile.component.html',
  styleUrls: ['./lagerplatzzeile.component.css']
})
export class LagerplatzzeileComponent implements OnInit {
 @Input() platz: Lagerplatz;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/lagerplatzzeile/lagerplatzzeile.component.ts